import { FormatRegistry, Static, TSchema } from '@sinclair/typebox';
import {
    TypeCheck,
    TypeCompiler,
    ValueError,
} from '@sinclair/typebox/compiler';
import { assert } from './errors';
import { DATE_REGEXP, DATE_TIME_REGEXP, EMAIL_REGEXP } from './regexp';

FormatRegistry.Set('date', (value) => DATE_REGEXP.test(value));
FormatRegistry.Set('date-time', (value) => DATE_TIME_REGEXP.test(value));
FormatRegistry.Set('email', (value) => EMAIL_REGEXP.test(value));

/**
 * Cache of compiled TypeBox schemas
 */
const cache = new Map<TSchema, TypeCheck<any>>();

/**
 * Typecheck a value against a TypeBox schema (memoized)
 *
 * Ref: https://github.com/sinclairzx81/typebox/issues/219#issuecomment-1207326791
 */
export function typecheck<T extends TSchema>(
    schema: T,
    value: unknown,
    errCallback: (errors: ValueError[]) => never // must throw
): asserts value is Static<T> {
    if (!cache.has(schema)) cache.set(schema, TypeCompiler.Compile(schema));
    const compiled = cache.get(schema);
    assert(compiled, 'Missing compiled typechecker');
    if (!compiled.Check(value)) {
        errCallback(Array.from(compiled.Errors(value)));
    }
}
